import { render, staticRenderFns } from "./applicantAddr.vue?vue&type=template&id=58aec38c"
import script from "./applicantAddr.vue?vue&type=script&lang=js"
export * from "./applicantAddr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports